module.exports = __webpack_public_path__ + "img/電気回路_1_4_5.caaea741.png";